import React, { Fragment, useEffect, useState } from "react";
import "./orderSummary.scss";
import {
  Button,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Snackbar,
} from "@mui/material";
import cartStore from "../../../store/cartStore";
import productStore from "../../../store/productStore";
import couponStore from "../../../store/couponStore";
import authStore from "../../../store/authStore";
import { useNavigate } from "react-router-dom";

// Icon
import CloseIcon from "@mui/icons-material/Close";

const OrderSummary = ({ activeStep, nextStep, isCouponError }) => {
  const CartStore = cartStore();
  const ProductStore = productStore();
  const CouponStore = couponStore();
  const AuthStore = authStore();
  const navigate = useNavigate();

  useEffect(() => {
    CouponStore.setCopyCouponCode({ code: null });
  }, []);

  useEffect(() => {
    if (CartStore.cartProduct && ProductStore.mProduct) {
      let subTotal = 0;
      let discount = 0;
      CartStore.cartProduct.map((item) => {
        ProductStore.mProduct.map((product) => {
          if (item.productID === product._id) {
            subTotal = subTotal + product.regularPrice * item.qty;
            if (product.salePrice) {
              discount =
                discount +
                (product.regularPrice - product.salePrice) * item.qty;
            }
          }
        });
      });
      const total = subTotal - discount;
      CartStore.setAmount({ name: "subTotalAmount", value: subTotal });
      CartStore.setAmount({ name: "discountAmount", value: discount });
      CartStore.setAmount({ name: "beforeCouponAmount", value: total });
      CartStore.setAmount({ name: "totalAmount", value: total });
    } else {
      CouponStore.clearApplyCouponCode();
    }
  }, [
    CartStore.cartProduct && CartStore.cartProduct.length,
    CartStore.cartProduct,
    ProductStore.mProduct,
  ]);

  useEffect(() => {
    if (
      CouponStore.applyCouponCode.couponCode !== "" &&
      CouponStore.copyCouponCode
    ) {
      setAmount();
    }
  }, [CartStore.beforeCouponAmount]);

  const applyCoupon = async () => {
    if (CartStore.couponAmount !== 0) {
      CartStore.setAmount({ name: "couponAmount", value: 0 });
      if (CartStore.beforeCouponAmount !== 0) {
        CartStore.setAmount({
          name: "totalAmount",
          value: CartStore.beforeCouponAmount,
        });
      }
      CouponStore.clearApplyCouponCode();
    } else {
      if (CouponStore.applyCouponCode.couponCode === "") {
        CouponStore.setApplyCouponCode({
          name: "isCouponError",
          value: true,
        });
        CouponStore.setApplyCouponCode({
          name: "isCouponErrorMessage",
          value: "enter Coupon Code",
        });
        CartStore.setAmount({ name: "couponAmount", value: 0 });
        if (CartStore.beforeCouponAmount !== 0) {
          CartStore.setAmount({
            name: "totalAmount",
            value: CartStore.beforeCouponAmount,
          });
        }
      } else {
        const isValid = await CouponStore.checkCoupon({
          couponName: CouponStore.applyCouponCode.couponCode
            .toUpperCase()
            .trim(),
        });
        if (isValid) {
          // setAmount();
        } else {
          CouponStore.setApplyCouponCode({
            name: "isCouponError",
            value: true,
          });
          CouponStore.setApplyCouponCode({
            name: "isCouponErrorMessage",
            value: "in valid coupon code",
          });
          CartStore.setAmount({ name: "couponAmount", value: 0 });
          if (CartStore.beforeCouponAmount !== 0) {
            CartStore.setAmount({
              name: "totalAmount",
              value: CartStore.beforeCouponAmount,
            });
          }
        }
      }
    }
  };

  const setAmount = () => {
    if (CouponStore.copyCouponCode) {
      if (
        CouponStore.copyCouponCode.minOrderValue < CartStore.beforeCouponAmount
      ) {
        CouponStore.setApplyCouponCode({
          name: "isCouponError",
          value: false,
        });
        const cDiscount =
          (CartStore.beforeCouponAmount * CouponStore.copyCouponCode.discount) /
          100;
        const tot = CartStore.beforeCouponAmount - Math.round(cDiscount);
        CartStore.setAmount({
          name: "couponAmount",
          value: Math.round(cDiscount),
        });
        CartStore.setAmount({ name: "totalAmount", value: tot });
        setOpen(true);
      } else {
        CartStore.setAmount({
          name: "couponAmount",
          value: 0,
        });
        CouponStore.setApplyCouponCode({
          name: "isCouponError",
          value: true,
        });
        CouponStore.setApplyCouponCode({
          name: "isCouponErrorMessage",
          value: `minimum order amount is ${CouponStore.copyCouponCode.minOrderValue}`,
        });
        if (CartStore.beforeCouponAmount !== 0) {
          CartStore.setAmount({
            name: "totalAmount",
            value: CartStore.beforeCouponAmount,
          });
        } else {
          CouponStore.setApplyCouponCode({
            name: "isCouponError",
            value: false,
          });
        }
      }
    }
  };

  useEffect(() => {
    setAmount();
  }, [CouponStore.copyCouponCode && CouponStore.copyCouponCode.minOrderValue]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const action = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <div className="order-summary">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        message="Apply Successfully"
        action={action}
      />
      <div className="main-title">
        <h3>Order Summary</h3>
      </div>
      <div className="order-summary-content">
        <div className="sub-total item">
          <p className="title">Sub Total</p>
          <p className="amount">₹{CartStore.subTotalAmount}</p>
        </div>
        <div className="discount item">
          <p className="title">Discount</p>
          <p className="amount">₹{CartStore.discountAmount}</p>
        </div>
        <div className="shipping item">
          <p className="title">Shipping Charges</p>
          <p className="amount">Free</p>
        </div>
        <Divider />
        {CartStore.couponAmount !== 0 && (
          <>
            <div className="-before-coupon-discount item">
              <p className="title"></p>
              <p className="amount">₹{CartStore.beforeCouponAmount}</p>
            </div>
            <div className="coupon-discount item">
              <p className="title">Coupon Discount</p>
              <p className="amount">₹{CartStore.couponAmount}</p>
            </div>
          </>
        )}
        <div className="total item">
          <h3 className="title">Total Amount</h3>
          <h3 className="amount">₹{CartStore.totalAmount}</h3>
        </div>
        {AuthStore.isLogged && activeStep === 0 && (
          <div className="coupon-code">
            <FormControl fullWidth>
              <OutlinedInput
                type="text"
                className="outlinedInput"
                placeholder="Enter Coupon Code"
                value={CouponStore.applyCouponCode.couponCode}
                onChange={(e) => {
                  CouponStore.setApplyCouponCode({
                    name: "couponCode",
                    value: e.target.value,
                  });
                }}
                disabled={CartStore.couponAmount !== 0 ? true : false}
                error={isCouponError}
                endAdornment={
                  <InputAdornment position="end">
                    <Button
                      aria-label="toggle password visibility"
                      edge="end"
                      className="btn"
                      onClick={applyCoupon}
                    >
                      {CartStore.couponAmount !== 0 ? (
                        <p>Clear</p>
                      ) : (
                        <p>Apply</p>
                      )}
                    </Button>
                  </InputAdornment>
                }
              />
              {CouponStore.applyCouponCode.isCouponError && (
                <FormHelperText
                  sx={{
                    color: "#cc0000",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {CouponStore.applyCouponCode.isCouponErrorMessage}
                  <Button
                    size="small"
                    onClick={CouponStore.clearApplyCouponCode}
                  >
                    Clear
                  </Button>
                </FormHelperText>
              )}
            </FormControl>
          </div>
        )}
      </div>
      {activeStep !== 1 && (
        <div className="btn-container">
          {AuthStore.isLogged ? (
            <Button
              onClick={nextStep}
              variant="contained"
              fullWidth
              color="inherit"
              className="btn"
            >
              <p>
                {activeStep === 0
                  ? "Checkout"
                  : activeStep === 2 && "Complete Order"}
              </p>
            </Button>
          ) : (
            <div className="not-sing-in">
              <Divider />
              <div className="not-sing-in-title">
                Please Sign up/Sign in after you will checkout order.
              </div>
              <Button
                onClick={() => navigate("/sign-up")}
                variant="contained"
                fullWidth
                color="inherit"
                className="btn"
              >
                <p>Sign Up</p>
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
